import { useState, memo } from "react";
import type { MappedStuck } from "../../types";
import styles from "../../Dashboard.module.scss";
import { DataRow } from "../Common/DataRow";
import { HEADERS } from "../../constants/metrics";

interface StuckRowProps {
  stuck: MappedStuck;
  index: number;
}

const StuckRowComponent = ({ stuck, index }: StuckRowProps) => {
  const [isOpen, setIsOpen] = useState(false);

  const rowLabel = (
    <div
      className={styles.productNameWrap}
      onClick={() => setIsOpen((prev) => !prev)}
    >
      <div className={styles.productName}>
        <span className={styles.numberBadge}>{index + 1}</span>
        <span>Склейка № {index + 1}</span>
        <svg
          className={`${styles.dropdownIcon} ${isOpen ? styles.open : ""}`}
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M6 9L12 15L18 9"
            stroke="#3C91E6"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </div>
    </div>
  );

  const nestedContent = isOpen && (
    <div className={styles.nestedArticle}>
      {stuck.items.map((item) => (
        <div key={item.nm_id} className={styles.nestedArticleItem}>
          <div className={styles.nestedTitleWrap}>
            <div className={styles.nestedTitle}>{item.vendor_code}</div>
          </div>
          <DataRow item={item} columns={HEADERS} />
        </div>
      ))}
    </div>
  );

  return (
    <div className={styles.tableRow}>
      <div className={styles.productCell}>
        {rowLabel}
        <DataRow item={stuck} columns={HEADERS} />
        {nestedContent}
      </div>
    </div>
  );
};

export const StuckRow = memo(StuckRowComponent);
